import React, { useEffect, useState } from "react";
import ProductCardGrid from "../components/ProductCardGrid";
import axios from "axios";
import SummaryApi from "../common/SummaryApi";
import { useNavigate, useLocation  } from "react-router-dom";

const SimilarProducts = ({ productId, title, showViewAll = false }) => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const finalProductId = productId || location.state?.productId;
  const pageTitle = title || location.state?.title || "Similar Products";
  const isSimilarProductsPage = location.pathname === "/similar-products";

  useEffect(() => {
     if (!finalProductId) return;

    const fetchSimilarProducts = async () => {
      try {
        setLoading(true);
        
        const res = await axios({
          url: SummaryApi.getSimilarProducts.url(finalProductId),
          method: SummaryApi.getSimilarProducts.method,
        });

        if (res.data.success) {
          setProducts(res.data.products || []);
        } else {
          setProducts([]);
        }

      } catch (err) {
        console.error("Failed to fetch similar products", err);
        setProducts([]);
      } finally {
        setLoading(false);
      }
    };

    fetchSimilarProducts();
  }, [finalProductId]);

    const handleViewAll = () => {
      navigate("/similar-products", {
        state: {
          productId,
          title
        }
      });
    };

  return (
    <section className={`overflow-hidden py-10 ${isSimilarProductsPage ? "px-4 md:px-6" : ""} `}>
      {/* HEADER */}
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-medium">{pageTitle}</h3>

        {showViewAll && (
          <button className="text-sm text-blue-600"
          onClick={handleViewAll}
          >
            View All
          </button>
        )}
      </div>

      {/* GRID */}
      {loading ? (
        <p className="text-gray-500">Loading...</p>
      ) : products.length === 0 ? (
        <p className="text-sm text-gray-500">
          No similar products found.
        </p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6 overflow-hidden">
          {products.map((item) => (
            <ProductCardGrid key={item._id} product={item} />
          ))}
        </div>
      )}
    </section>
  );
};

export default SimilarProducts;
